__turbopack_context__.v({
  "container": "Container-module__dNd4ua__container",
});
